<!--
 功能名称:千里眼平台(技师)-业绩详情
 开发人:梁高权
 创建时间:2021/04/08
 最后修改时间:2021/04/08
-->
<template>
  <div class="service-wrap">
    <timeScreen :active="active" v-on:timeChange="timeChange($event)"/>
    <synchronizeTime/>
    <div class="Detail" v-show="serviceList.length>0">
      <div class="title line">
        <span v-for="(item,index) in titleList" :key="index">{{item}}</span>
      </div>
      <ul>
        <li v-for="(item,index) in serviceList" :key="index">
          <div class="name" @click="item.show=!item.show">
            <span>{{item.group_name}}</span>
            <van-icon :name="item.show?'arrow-up':'arrow-down'" color="#666" />
          </div>
          <div v-show="item.show" class="line" v-for="(items,indexs) in item.list" :key="indexs">
            <span>{{items.working_type}}</span>
            <span>{{items.service_num}}</span>
            <span>¥{{items.total_money}}</span>
            <span>{{items.ext_service_num}}</span>
            <span>¥{{items.ext_total_money}}</span>
          </div>
        </li>
      </ul>
      <div class="sumUp">
        <span>合计</span>
        <div>
          <span>{{sumUp.num}}</span>
          <span>¥{{sumUp.money}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import table from '@/api/table'
// import util from '@/utils/util'
export default {
  name: 'service',
  components: {
    'timeScreen':() => import('./timeScreen'),
    'synchronizeTime':() => import('./synchronizeTime')
  },
  filters: {},
  mixins: [],
  props: {
    active:Number
  },
  data () {
    return {
      titleList:['上钟类型','正班数量','正班提成','加班数量','加班提成'],
      serviceList:[],
      sumUp:new Object()
    }
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    timeChange(val){
      if(this.active===0) this.serviceDetail(val)
    },
    // 获取业绩详情
	  serviceDetail(data){
	    table.serviceDetail(data).then(res=>{
        let serviceNum=0,totalMoney=0,extServiceNum=0,extTotalMoney=0;
        res.data.list.forEach((item,index)=>{
          item.show=true
          // if(index==0){item.show=true}else{item.show=false}
          for(let i=0;i<item.list.length;i++){
            serviceNum+=item.list[i].service_num
            totalMoney+=item.list[i].total_money
            extServiceNum+=item.list[i].ext_service_num
            extTotalMoney+=item.list[i].ext_total_money
          }
        })
        this.sumUp={num:serviceNum+extServiceNum,money:totalMoney+extTotalMoney}
        this.serviceList=res.data.list
	    })
	  }
  }
}
</script>
<style lang="scss" scoped>
  .service-wrap {
    .Detail{
      margin: 22px auto 30px;
      padding: 1px 25px 1px;
      background:#fff;
      width: 690px;
      border-radius: 16px;
      .line{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
          width: 96px;
          text-align: center;
        }
      }
      .title{
        color: #999;
        font-size: 23px;
        margin-top: 40px;
      }
      ul{
        border-bottom: 2px solid #EAEAEA;
        padding-bottom: 55px;
        li{
          margin-top: 37px;
          .name{
            color:#333;
            font-size: 28px;
            >span{
              margin-right: 10px;
            }
          }
          .line{
            line-height: 72px;
            color: #666666;
            font-size: 28px
          }
          .line:nth-of-type(odd){background: #F1F1F1;border-radius: 10px}
        }
      }
      .sumUp{
        display: flex;
        justify-content: space-between;
        line-height: 90px;
        >span{
          color: #333;
          font-size: 28px;
          font-weight: bold;
        }
        >div{
          width: 230px;
          display: flex;
          justify-content: space-between;
          color: #691BFF;
          font-size: 28px;
          font-weight: bold;
          span{width: 96px;text-align:center;}
        }
      }
    }
  }
</style>
